import { IOauthToken, IUser } from 'src/models';
import { ILoginData, IRegister } from 'src/screens';
import { IPasswordChangeRequest, IPasswordResetRequest } from 'src/screens/auth/types';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

const SUB_URL = '/user';

/** 로그인 */
export const login = async (loginData: ILoginData) => {
  try {
    const url = `${SUB_URL}/login`;

    const response = await instance.post<TApiResponseData<IOauthToken>>(url, loginData);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 로그아웃 */
export const logout = async () => {
  try {
    const url = `${SUB_URL}/logout`;

    const response = await instance.get<TApiResponseData<IUser>>(url);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 내 정보 조회 */
export const getUserProfile = async () => {
  try {
    const url = `${SUB_URL}/profile`;

    const response = await instance.get<TApiResponseData<IUser>>(url);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 아이디 중복 확인 */
export const checkDuplicateLoginId = async (loginId: string) => {
  try {
    const url = `${SUB_URL}/check/duplicate/loginId`;
    const payload = { loginId };

    const response = await instance.post<TApiResponseData<boolean>>(url, payload);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 아이디 찾기 */
export const findLoginId = async (verifyKey: string) => {
  try {
    const url = `${SUB_URL}/find/loginId`;
    const payload = {
      verifyKey,
    };

    const response = await instance.post<TApiResponseData<string>>(url, payload);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 비밀번호 재설정 (로그인 이전) */
export const resetPwd = async (data: IPasswordResetRequest) => {
  try {
    const url = `${SUB_URL}/reset/pwd`;

    const response = await instance.put<TApiResponseData<null>>(url, data);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 토큰 재발급 */
export const loginRefresh = async (refreshToken: string) => {
  try {
    const url = `${SUB_URL}/login/refresh`;
    const payload = {
      refreshToken,
    };

    const response = await instance.post<TApiResponseData<IOauthToken>>(url, payload);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 비밀번호 변경(로그인 이후) */
export const changePwd = async (data: IPasswordChangeRequest) => {
  try {
    const url = `${SUB_URL}/change/pwd`;

    const response = await instance.put<TApiResponseData<null>>(url, data);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 회원가입 */
export const signup = async (formData: IRegister) => {
  try {
    const url = `${SUB_URL}/signup`;

    const response = await instance.post<TApiResponseData<IOauthToken>>(url, formData);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 언어 변경 */
export const changeLanguage = async (langCd: string, refreshToken: string | null) => {
  try {
    const url = `${SUB_URL}/lang`;
    const payload = {
      refreshToken,
      langCd,
    };

    const response = await instance.put<TApiResponseData<IOauthToken>>(url, payload);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 회원탈퇴 */
export const withdrawal = async () => {
  try {
    const url = `${SUB_URL}/withdrawal`;

    const response = await instance.delete<TApiResponseData<null>>(url);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};
